import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './FAQ.css';

const FAQ = () => {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = t('faq.list', { returnObjects: true });

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="faq">
      <div className="container">
        <div className="faq-content">
          <h2 className="faq-title" data-aos="fade-up">{t('faq.title')}</h2>
          <p className="faq-subtitle" data-aos="fade-up" data-aos-delay="100">{t('faq.subtitle')}</p>
          <div className="faq-list">
            {faqs.map((faq, index) => (
              <div key={index} className="faq-item" data-aos="fade-up" data-aos-delay={(index + 1) * 50}>
                <button 
                  className="faq-question"
                  onClick={() => toggleFAQ(index)}
                >
                  <span>{faq.q}</span>
                  <span className={`faq-arrow ${openIndex === index ? 'open' : ''}`}>
                    ▼
                  </span>
                </button>
                {openIndex === index && (
                  <div className="faq-answer">
                    <p>{faq.a}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;



